import React, { useEffect } from "react";
import DiscountCodes from "./components/DiscountCodes";
import Booking from "redux/slices/booking";
import Bookings from "./components/Bookings";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
const Admin = () => {
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();
  useEffect(() => {
    console.log("Admin rendered");

    const allowedDomains = ["@letscreateweb.com", "@themirum.co.uk"];

    if (!user?.email) {
      history.push("/login");
    } else if (
      user.email &&
      !allowedDomains.some((domain) => user.email.includes(domain))
    ) {
      history.push("/login");
    }
  }, [user?.email]);

  return (
    <>
      <Helmet>
        <title>admin</title>
      </Helmet>
      <div className="p-8 text-center">
        <h1 className="w-full text-center">Mirum Admin</h1>
        {/* <Bookings /> */}
        {/* <DiscountCodes /> */}

        <div className="flex flex-col gap-4 p-8">
          <a href="/admin/bookings">Bookings</a>
          <a href="/admin/discount-codes">Discount Codes</a>
        </div>
      </div>
    </>
  );
};

export default Admin;
